// Dependencias generales
import React from "react";
import { useEffect } from 'react';



// Función del router
const CurrentDayForecasting = (params) => {    

    useEffect(() => {                 
      console.log("Detalle forecasting METEO cargado correctamente.")      
    }, [params]);


      const listDayForecasting = params.objDayForecasting.map((timeframe,index) =>
      
        { if ( parseInt(timeframe.Timeframe.split("-")[1]) >= parseInt(new Date().getHours()) ){
            return <React.Fragment key={timeframe.Timeframe}>
                    <li className="horizontal gap-04 center">
                      <figure className="avatar size-l"><img id={"iconoTiempoHoy"+timeframe.Timeframe+index} src={"https://www.aemet.es/imagenes_gcd/_iconos_municipios/"+timeframe.SkyStatusValue+".png"} alt="" onError={() => document.getElementById("iconoTiempoHoy"+timeframe.Timeframe+index).src = "/img/unknownWeather.png"}/></figure>
                      <dl className="vertical fill">
                        <dt id={"etiquetaDayForecasting"+timeframe.Timeframe} className="size-m">De {timeframe.Timeframe.split("-")[0]+":00 h a "+timeframe.Timeframe.split("-")[1]+":00 h"}</dt>              
                        <dd id={"valorDayForecasting"+timeframe.Timeframe} className="size-l"> {timeframe.SkyStatus}</dd>
                        <dd id={"valorDayForecasting"+timeframe.Timeframe} className="size-l"> {timeframe.Temperature}ºC</dd>
                      </dl> 
                    </li>                
                  </React.Fragment>        
          }

          else return <React.Fragment key={timeframe.Timeframe}></React.Fragment>

        }
      

      );    

      return (
        <>        
        {listDayForecasting}          
        </>
      )

}

export default CurrentDayForecasting